import { PROFILE, MANIFESTO } from "../data/content";
import { LineReveal, Rise, WordReveal } from "./motion/Reveal";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative mx-auto max-w-[1400px] px-5 py-28 md:px-12 md:py-40">
      <div className="mb-16 flex items-baseline gap-4">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-electric">(About)</span>
        <div className="h-px flex-1 bg-white/10" />
      </div>

      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        {/* Sticky name / title */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-24">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-electric">Bonnie Gonzalez</span>
            <p className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tighter text-cream md:text-6xl">
              {PROFILE.name}
            </p>
            <p className="mt-3 font-mono text-[0.72rem] uppercase tracking-[0.2em] text-electric">{PROFILE.title}</p>
          </div>
        </div>

        {/* Manifesto chapters */}
        <div className="lg:col-span-7">
          <h2 className="mb-8 font-heading text-4xl font-bold leading-tight tracking-tight md:text-6xl">
            <LineReveal
              lines={["Fashion, engineered", "for the digital era."]}
              className="block"
            />
          </h2>

          <div className="mb-14 space-y-6 border-l-2 border-electric/40 pl-6" data-testid="about-intro">
            <p className="font-body text-lg font-light leading-relaxed text-white/80 md:text-xl">
              <WordReveal text="I'm a Technical Designer working across women's, men's, and youth apparel, from cut-and-sew knits and wovens to outerwear, swimwear, and knitwear. With a digital-first mindset, I use CLO not just to build patterns and refine fit, but to accelerate the entire development process." />
            </p>
            <p className="font-body text-base font-light leading-relaxed text-white/60">
              <WordReveal text="To me, 3D development is far more than creating digital garments; it's using the files, data, and visual assets generated along the way to give factories clear, detailed direction and set them up for successful product execution. Blending creative design, graphic development, and deep technical product knowledge, I turn concepts into production-ready digital samples that power design reviews, customer presentations, and assortment planning across apparel, accessories, and 3D product development." />
            </p>
          </div>

          <div className="space-y-14">
            {MANIFESTO.map((m) => (
              <div key={m.n} className="group border-t border-white/10 pt-6" data-testid={`manifesto-${m.n}`}>
                <div className="flex items-start gap-6">
                  <span className="font-mono text-sm text-electric transition-colors group-hover:text-magenta">{m.n}</span>
                  <div>
                    <Rise>
                      <h3 className="font-heading text-2xl font-semibold text-cream md:text-3xl">{m.title}</h3>
                    </Rise>
                    <p className="mt-3 font-body text-base font-light leading-relaxed text-white/60">
                      <WordReveal text={m.body} />
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
